<template>

    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg ">

                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">COVID-19 Update</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row justify-content-center mt--100">
                    <div class="col-lg-12">
                        <card gradient="white" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">{{post.text1}}</h4>
                            <p class="mt-4">{{post.text2}}</p>
                            <p>{{post.text3}}</p>
                            <div class="text-center mb-5 mt-5">
                                <img v-lazy="'img/brand/pandas/panda_v10.gif'" class="img-fluid rounded shadow"
                                     style="width: 350px;">
                            </div>
                            <p>{{post.text4}}</p>
                            <p>{{post.text5}}</p>
                            <p>{{post.text6}}</p>
                            <p>Email: <a v-on:click="tracker('Contact', 'Emailed contact', 'Link from covid blog')"
                                    href="mailto:contact@offthecouchgames.com">contact@offthecouchgames.com</a></p>
                            <p>Phone: 408-478-2341</p>
                            <p>{{post.text7}}</p>
                            <p>{{post.text8}}</p>


                            <div class="row mt-5 ml-1">
                                <small>Tags:
                                    <badge pill type="primary">covid-19</badge>
                                    <badge pill type="primary">announcement</badge>
                                    <badge pill type="primary">promotion</badge>
                                </small>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="ml-3">
                                    <img v-lazy="'img/brand/people/nick.jpg'" alt="Circle image"
                                         class="img-fluid rounded-circle shadow" style="width: 70px;">
                                </div>
                                <div class="ml-2">
                                    <h6 class="font-weight-800">{{post.author}}</h6>
                                    <p>Founder of OTC and Escape Room fanatic</p>

                                </div>
                            </div>


                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "CoronaUpdate",
        data () {
            return {
                post: {
                    text1: "Hi Everyone!",
                    text2: "With the ongoing concerns about the COVID-19 outbreak, Off The Couch’s top priority is the safety of our customers and our employees.  To continue the battle against COVID-19,  the Public Health Office and Santa Clara County leadership has extended the Shelter in Place order until the end of May.  Due to this, we will be remaining closed until the shelter is lifted.",
                    text3: "You may book any of our experiences after May 31.  Our cancellation policy is flexible and we allow for rescheduling or full credit refunds if anything comes up.  Our available slots will also be restricted a bit to ensure proper social distancing even after the shelter is lifted.  We want to ensure that people are able to remain a safe distance from another and there is no contact between individuals outside of their respective groups.",
                    text4: "Alternatively, if you’d like to continue to support us, please consider purchasing a gift card from our website.",
                    text5: "We are currently offering a 20% bonus to all gift card values.  Gift certificates never expire and can be used at anytime for a future booking for yourself or others. Any help is greatly appreciated during this time and we look forward to seeing you soon.",
                    text6: "If you need to reach us, email or call.",
                    text7: "Thank you for understanding and support.  We look forward to seeing everyone soon!",
                    text8: "The OTC Team",
                    title: "COVID-19 Update",
                    abstract: "With the ongoing concerns about the COVID-19 outbreak, Off The Couch’s top priority is the safety of our customers and our employees.  To continue the battle against COVID-19,  the Public Health Office and Santa Clara County leadership has extended the Shelter in Place order until the end of May.  Due to this, we will be remaining closed until the shelter is lifted...",
                    datePosted: "May 12, 2020",
                    author: "Nick",
                    category: "announcements"
                }
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>

</style>
